import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { app, IS_HYBRID_CART_ACTIVE, settings, user } from 'core';
import { actions } from 'core/use-cases/user';
import { actions as actionsCart } from 'core/use-cases/cart/actions';

import { addPageAction, STEP_EXTENDED_CAPTATION, Cookies } from 'core/utilities';
import { formatCycle } from 'core/utilities/strings/format-cycle';
import { useGetFeatureFlag } from 'ui/hooks';

export function useChooseCycle() {
  const history = useHistory();
  const dispatch = useDispatch();
  const homePath = settings.hooks.useHomepage();
  const isMobile = app.hooks.useApp('isMobile');

  const [step, setStep] = useState<string>('choose-cycle');

  const {
    data: { resellerId, avaliableCycles, cycle },
  } = user.hooks.useUser();

  const { value: isHybridCartActive } = useGetFeatureFlag(IS_HYBRID_CART_ACTIVE, false, resellerId);

  const boticarioCycles = avaliableCycles.cycles.filter(
    (cy) => cy.brand === 'BOTICARIO' && cy.currentCycle !== cycle.currentCycle,
  );

  const goToNewCycle = () => {
    dispatch(actions.changeCycle.request({ cycle: cycle.currentCycle }));
  };

  function showExtendedCycle() {
    setStep(STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE);
  }

  function showNewCycle() {
    setStep(STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE);
  }

  function backToChooseCycle() {
    setStep(STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE);
  }

  function stayInExtendedCycle() {
    addPageAction(STEP_EXTENDED_CAPTATION.CHOOSE_EXTENDED_CYCLE, { resellerId });
    localStorage.setItem(`choose-extended-cycle-${resellerId}`, 'true');
    Cookies.set('currentCycle', `${cycle.currentCycle}`, { domain: '.boticario.com.br' });

    history.push(homePath);

    if (isHybridCartActive) {
      dispatch(actionsCart.lastCartFetch.request());
    } else {
      dispatch(actionsCart.cartFetch.request());
    }
  }

  const getPrimaryActionLabel = {
    [STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE]: `Ir para o Ciclo ${formatCycle(
      boticarioCycles[0]?.currentCycle || 0,
    )}`,
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE]: `Ir para o Ciclo ${formatCycle(
      boticarioCycles[0]?.currentCycle || 0,
    )}`,
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE]: `Continuar no Ciclo ${formatCycle(
      cycle.currentCycle || 0,
    )}`,
  };

  const getPrimaryAction = {
    [STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE]: showNewCycle,
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE]: goToNewCycle,
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE]: stayInExtendedCycle,
  };

  const getSecondaryActionLabel = {
    [STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE]: `Continuar no Ciclo ${formatCycle(cycle.currentCycle)}`,
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE]: 'Voltar',
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE]: 'Voltar',
  };

  const getSecondaryAction = {
    [STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE]: showExtendedCycle,
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE]: backToChooseCycle,
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE]: backToChooseCycle,
  };

  const getMessage = {
    [STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE]:
      'Você pode continuar no ciclo estendido no período de tolerância de 2 dias ou atualizar para o novo ciclo.',
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE]:
      'Você tem certeza que deseja ir para o novo ciclo? Após fazer a atualização não será possível retornar para o ciclo estendido.',
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE]:
      'Você tem certeza que deseja continuar no ciclo estendido? Você poderá ficar nele por até 2 dias.',
  };

  const getTitle = {
    [STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE]: 'Escolha o ciclo',
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE]: 'Confirmação de escolha',
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE]: 'Confirmação de escolha',
  };

  const floraSection = {
    [STEP_EXTENDED_CAPTATION.CHOOSE_CYCLE]: 'escolha-o-ciclo',
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_NEW_CYCLE]: 'confirmacao-de-escolha',
    [STEP_EXTENDED_CAPTATION.CONFIRMATION_EXTENDED_CYCLE]: 'confirmacao-de-escolha',
  };

  return {
    getTitle,
    step,
    isMobile,
    getMessage,
    getSecondaryAction,
    getPrimaryAction,
    getPrimaryActionLabel,
    getSecondaryActionLabel,
    floraSection,
  };
}
